import React, { useState } from "react";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

import TutorialDataService from "../services/tutorial.service";
import AddMarkerFromAddress from "./AddMarkerFromAddress";
import PhoneNumbers from "./PhoneNumbers";
import WeekTable from "./WeekTable";

import firebase from "firebase/app";

const EditTutorial = ({ tutorial, setActiveTutorial, comments }) => {
  // console.log( tutorial.apertura );

  const center = {
    lat: tutorial.location.latitude,
    lng: tutorial.location.longitude,
  };

  // Geographical data
  const [location, setLocation] = useState(center);

  // Messages and status
  // const [submitted, setSubmitted] = useState(false);
  const [published, setPublished] = useState(tutorial.published);
  const [message, setMessage] = useState("");

  const [error, setError] = useState(null);

  // Main data
  const [title, setTitle] = useState(tutorial.title);
  const [rscf, setRsCf] = useState(tutorial.rscf);
  // Category
  const [category, setCategory] = useState(tutorial.mainCategory);
  const [allcat, setAllCat] = useState(tutorial.allcategory);

  // Category management
  // const [category, setCategory] = useState('1');
  // const [allcat, setAllCat] = useState(catmerc);
  var apo = new Array(11).fill(1);
  apo.splice(tutorial.mainCategory - 1, 0, 0);

  const [subcatblock, setSubcatblock] = useState(apo);
  const [checksubcatmess, showMessage] = useState(true);
  const [validCat, setValidCat] = useState(false);

  const onSelectCategory = (event) => {
    const { name, value } = event.currentTarget;
    // setCategory(value);
    // console.log(name);
    // console.log(value);
    const test = value - 1;
    // console.log(test);
    var appo = new Array(11).fill(1);
    appo.splice(test, 0, 0);
    // console.log(subcatblock[test]);
    setCategory(value);
    setSubcatblock(appo);
    // reset all the Category
    const another = [...allcat];
    another.map((x) => {
      // console.log(x);
      if (x.code != value) {
        x.subcat.map((sb) => {
          // console.log(sb);
          sb.status = false;
        });
      }
    });
  };
  const catCheckboxChange = (e) => {
    const { name, checked } = e.target;
    // console.log(name);
    // console.log(checked);
    const arr = name.split(".");

    const cat = arr[0] - 1;
    const subcat = arr[1] - 1;
    const catsubcat = [...allcat];

    // console.log(catsubcat[cat].subcat[subcat]);
    catsubcat[cat].subcat[subcat].status = checked;

    setAllCat(catsubcat);

    const emparr = [];
    const another = [...allcat];
    another[cat].subcat.map((x) => {
      emparr.push(x.status);
    });

    // const result = allEqual(emparr)
    const result = emparr.every((val, i, arr) => val === arr[0]);

    if (result && emparr[0] == false) {
      // console.log('all FALSE');
      setValidCat(false);
    } else {
      setValidCat(true);
    }

    // console.log(validCat);
  };

  const [familycard, setFamilycard] = useState(tutorial.familycard);
  const [goldcard, setGoldcard] = useState(tutorial.goldcard);

  // Address
  // tutorial.address
  // console.log(tutorial.address);
  const addrarr = tutorial.address.split(",");
  addrarr.pop();
  const newaddress = addrarr.join("");
  // console.log(newaddress);

  // const [address, setAddress] = useState(tutorial.address);
  const [address, setAddress] = useState(newaddress);
  const [numero, setNumero] = useState(tutorial.numero);

  // Phone
  const phonesArray =
    tutorial.phones.length == 0
      ? [{ phone: "", whatsapp: false }]
      : tutorial.phones;
  const [phoneBook, setPhoneBook] = useState(phonesArray);

  // Email web site
  const [email, setEmail] = useState(tutorial.email);
  const [website, setWebsite] = useState(tutorial.website);
  const [facebook, setFacebook] = useState(tutorial.facebook);
  const [instagram, setInstagram] = useState(tutorial.instagram);
  const [twitter, setTwitter] = useState(tutorial.twitter);

  // Oarari e consegne
  const [apertura, setApertura] = useState(tutorial.apertura);
  const [checkCons, setCheckCons] = useState(tutorial.effetuapren);
  const [prenotazioni, setPrenotazioni] = useState(tutorial.prenotazioni);
  const [consegna, setConsegna] = useState(tutorial.consegna);
  const [costoConsegna, setCostoConsegna] = useState(tutorial.costoConsegna);
  const [checkPM, setCheckPM] = useState(tutorial.modpag); // modalità pagamento

  // Scontistica
  const [checkCards, setCheckCards] = useState(tutorial.sconti);
  const cardsCheckboxChange = (e) => {
    const { name, checked } = e.target;
    const arr = name.split("_");
    const c_list = [...checkCards];
    // console.log(c_list[arr[1]]);
    c_list[arr[1]].status = checked;
    setCheckCards(c_list);
  };

  const discountChange = (e) => {
    const { name, value } = e.target;
    const arr = name.split("_");
    const c_list = [...checkCards];
    // console.log(c_list[arr[1]]);
    c_list[arr[1]].discount = value;
    setCheckCards(c_list);
  };

  const specDiscountChange = (e) => {
    const { name, value } = e.target;
    // console.log(value);
    const arr = name.split("_");
    const c_list = [...checkCards];
    // // console.log(c_list[arr[1]]);
    c_list[arr[1]].description = value;
    setCheckCards(c_list);
  };

  // Commenti
  const commentsCheckboxChange = (e) => {
    // console.log(e.target);
    // The id is the comment id in the comments SUBcollection
    const { id, name, checked } = e.target;
    updateComments(id, checked);
  };

  const updateComments = async (commentId, status) => {
    // console.log('status');
    // console.log(commentId);
    TutorialDataService.updateComments(tutorial.id, commentId, {
      read: status,
    })
      .then(() => {
        setMessage("The Comment status was updated successfully!");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // Orari e consegne
  // Manage checkbox for consegna
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    // console.log(name);
    // console.log(checked);
    if (name === "checkCons") {
      setCheckCons(checked);
    }
  };

  // Modalità di pagamento
  const mpCheckboxChange = (e) => {
    const { name, checked } = e.target;
    // console.log(name);
    // console.log(checked);

    const arr = name.split("_");
    // console.log(arr[1]);

    const c_list = [...checkPM];
    // console.log(c_list[arr[1]]);
    c_list[arr[1]].status = checked;
    setCheckPM(c_list);
  };

  // Generale
  // Manage text input changes
  const onChangeHandler = (event) => {
    const { name, value } = event.currentTarget;

    if (name === "title") {
      setTitle(value);
    } else if (name === "email") {
      setEmail(value);
    } else if (name === "website") {
      setWebsite(value);
    } else if (name === "facebook") {
      setFacebook(value);
    } else if (name === "instagram") {
      setInstagram(value);
    } else if (name === "twitter") {
      setTwitter(value);
    } else if (name === "address") {
      setAddress(value);
    } else if (name === "numero") {
      setNumero(value);
    } else if (name === "costoConsegna") {
      setCostoConsegna(value);
    } else if (name === "rscf") {
      setRsCf(value);
    }
  };

  const updatePublished = async (event, status) => {
    // console.log('status');
    // console.log(status);
    TutorialDataService.update(tutorial.id, {
      published: status,
    })
      .then(() => {
        setPublished(status);
        setMessage("The status was updated successfully!");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const deleteTutorial = async (event) => {
    TutorialDataService.delete(tutorial.id)
      .then(() => {
        setActiveTutorial(null);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const [validated, setValidated] = useState(false);
  const handleSubmit = (event) => {
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      // console.log("FALSE");
      event.preventDefault();
      event.stopPropagation();
    } else {
      // When form is valid save the informations
      // console.log("UPDATING TUTORIAL");
      updateTutorial(event);
    }
    setValidated(true);
  };

  function capitalizeTheFirstLetterOfEachWord(words) {
    var separateWord = words.toLowerCase().split(" ");
    for (var i = 0; i < separateWord.length; i++) {
      separateWord[i] =
        separateWord[i].charAt(0).toUpperCase() + separateWord[i].substring(1);
    }
    return separateWord.join(" ");
  }

  function categoriesApp(cat) {
    const obj = {};
    cat.map((maincat, i) => {
      // console.log(maincat);
      // console.log(i);
      // const id = i+1;
      maincat.subcat.map((subcat, k) => {
        // console.log(subcat);
        if (subcat.status === true) {
          obj[maincat.code] = maincat.maincat;
          obj[subcat.code] = subcat.name;
        }
      });
    });
    // console.log(obj);
    return obj;
  }

  function convertTime(orario) {
    // console.log(orario);
    const arr = [];
    orario.map((x, i) => {
      if (x.open === true) {
        const tm = {
          d: x.name,
          mo: x.hours.morning.open,
          mc: x.hours.morning.close,
          ao: x.hours.aftern.open,
          ac: x.hours.aftern.close,
        };
        arr.push(tm);
      } else {
        arr.push({ d: x.name });
      }
    });
    // console.log(arr);
    return arr;
  }

  function convertSconti(sconti) {
    // console.log(sconti);
    const arr = [];
    sconti.map((x, i) => {
      if (x.status === true) {
        const tm = { n: x.label, s: x.discount, d: x.description };
        arr.push(tm);
      }
    });
    // console.log(arr);
    return arr;
  }

  const updateTutorial = async (event) => {
    event.preventDefault();

    // console.log(published);

    const geoLocation = new firebase.firestore.GeoPoint(
      location.lat,
      location.lng
    );

    const indirizzo =
      capitalizeTheFirstLetterOfEachWord(address) + ", " + numero;

    const catApp = categoriesApp(allcat);

    const hApeApp = convertTime(apertura);
    const hPrenApp = convertTime(prenotazioni);
    const hConsApp = convertTime(consegna);

    const scontApp = convertSconti(checkCards);

    const data = {
      // Card informazioni generali
      title: title.toUpperCase(),
      catApp: catApp,
      mainCategory: category,
      allcategory: allcat,
      address: indirizzo,
      numero: numero,
      rscf: rscf,

      // Card Posizione esercizio commerciale - Geographical data
      location: geoLocation,

      // Card contatti
      phones: phoneBook,
      email: email,
      website: website,
      facebook: facebook,
      instagram: instagram,
      twitter: twitter,

      // Card orari
      apertura: apertura,
      effetuapren: checkCons,
      prenotazioni: prenotazioni,
      consegna: consegna,
      hApeApp: hApeApp,
      hPrenApp: hPrenApp,
      hConsApp: hConsApp,
      modpag: checkPM,
      costoConsegna: costoConsegna,

      // Card scontistica
      sconti: checkCards,
      scontApp: scontApp,
    };

    TutorialDataService.update(tutorial.id, data)
      .then(() => {
        // console.log("Created new item successfully!");
        setMessage("Updated successfully!");
      })
      .catch((e) => {
        console.log(e);
        setError(e);
      });
  };

  return (
    <div className="container">
      <div className="row">
        {error !== null && <div className="col-md-12">{error}</div>}
        <div className="col-md-12">
          {published ? (
            <button
              className="badge badge-warning mr-2"
              onClick={(event) => {
                updatePublished(event, false);
              }}
            >
              Rimuovi da Pubblicazione
            </button>
          ) : (
            <button
              className="badge badge-primary mr-2"
              onClick={(event) => {
                updatePublished(event, true);
              }}
            >
              Pubblica
            </button>
          )}

          <button
            className="badge badge-danger mr-2"
            onClick={(event) => {
              deleteTutorial(event, false);
            }}
          >
            Cancella
          </button>

          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Button type="submit" className="badge badge-success">
              Aggiorna
            </Button>

            {message && <p>{message}</p>}

            {/* Card informazioni generali */}
            <div className="card">
              <div className="card-header">Informazioni generali</div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-row">
                      <div className="col-md-8">
                        <div className="row">
                          <Form.Group as={Col} md="6" controlId="title">
                            <Form.Label className="required">
                              Insegna
                            </Form.Label>
                            <Form.Control
                              required
                              type="text"
                              value={title}
                              onChange={(event) => onChangeHandler(event)}
                              name="title"
                              placeholder="Nome dell'esercizio commerciale"
                            />
                            {/* <Form.Control.Feedback>Nome esercizio accettato!</Form.Control.Feedback> */}
                            <Form.Control.Feedback type="invalid">
                              Il nome dell'esercizio commerciale è obbligatorio.
                            </Form.Control.Feedback>
                          </Form.Group>

                          <div className="form-group col-md-6">
                            <label htmlFor="category" className="required">
                              Tipologia merceologica
                            </label>
                            <select
                              className="form-control"
                              id="category"
                              name="category"
                              value={category}
                              onChange={(event) => onSelectCategory(event)}
                            >
                              {allcat.map((x) => {
                                return (
                                  <option key={x.code} value={x.code}>
                                    {x.maincat}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="row">
                          <Form.Group as={Col} md="12" controlId="description">
                            <Form.Label className="required">
                              Ragione sociale e Codice fiscale
                            </Form.Label>
                            <Form.Control
                              required
                              as="textarea"
                              rows={3}
                              aria-describedby="inputGroupPrepend"
                              value={rscf}
                              onChange={(event) => onChangeHandler(event)}
                              name="rscf"
                              placeholder="Questo dato verrà non verrà pubblicato online"
                            />
                          </Form.Group>
                        </div>
                      </div>

                      <div className="form-group col-md-4">
                        <div
                          className="text-danger"
                          {...(checksubcatmess ? { hidden: true } : {})}
                        >
                          Seleziona almeno un valore
                        </div>

                        {allcat.map((x) => {
                          // console.log(x);
                          const test = 1 * x.code - 1;
                          // console.log(test);
                          // { ...subcatblock[x.code] !== 0 ? console.log('uno') : console.log('due');}

                          return (
                            <div
                              key={x.code}
                              className="form-check"
                              name={x.code}
                              {...(subcatblock[test] !== 0
                                ? { hidden: true }
                                : {})}
                            >
                              {x.subcat.map((sbc, i) => {
                                return (
                                  <div key={sbc.code + i}>
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={sbc.status}
                                      name={sbc.code}
                                      onChange={(event) =>
                                        catCheckboxChange(event)
                                      }
                                    />

                                    <span>{sbc.name}</span>
                                    <br />
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-row">
                      <div className="form-group col-md-9">
                        <label htmlFor="address" className="required">
                          Indirizzo
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          value={address}
                          onChange={(event) => onChangeHandler(event)}
                          name="address"
                          placeholder="Via o Piazza"
                          required="required"
                        />
                        <span className="small">
                          20037, Paderno Dugnano (MI)
                        </span>
                      </div>
                      <div className="form-group col-md-3">
                        <label htmlFor="numero" className="required">
                          Numero civico
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="numero"
                          value={numero}
                          onChange={(event) => onChangeHandler(event)}
                          name="numero"
                          placeholder="Inserisci il numero civico"
                          required="required"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END Card informazioni generali */}

            {/* Card Posizione */}
            <div className="card">
              <div className="card-header">Posizione esercizio commerciale</div>
              <div className="card-body">
                <div className="form-row">
                  <div className="form-group col-md-12">
                    <AddMarkerFromAddress
                      center={center}
                      markerChange={(location) => setLocation(location)}
                      composedAddress={address}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* END Card Posizione */}

            {/* Card Contatti */}
            <div className="card">
              <div className="card-header">Contatti</div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-row">
                      <Form.Group as={Col} md="6" controlId="email">
                        <Form.Label>Indirizzo mail</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Inserisci email"
                          value={email}
                          onChange={(event) => onChangeHandler(event)}
                          name="email"
                        />
                        <Form.Control.Feedback type="invalid">
                          Email non valida.
                        </Form.Control.Feedback>
                      </Form.Group>

                      {/* for type URL see https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5/Constraint_validation*/}
                      <div className="form-group col-md-6">
                        <label htmlFor="website">Sito web</label>
                        <input
                          type="URL"
                          className="form-control"
                          id="website"
                          value={website}
                          onChange={(event) => onChangeHandler(event)}
                          name="website"
                          placeholder="Inserisci la URL del sito web"
                        />
                        <Form.Control.Feedback type="invalid">
                          Web site URL non valida
                        </Form.Control.Feedback>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-row">
                      <div className="col-md-6 form-group">
                        <div className="form-row">
                          <div className="form-group col-md-12">
                            <label htmlFor="exampleInputEmail1">
                              Recapiti telefonici
                            </label>
                            <PhoneNumbers
                              book={phoneBook}
                              phoneBookChange={(phoneBook) =>
                                setPhoneBook(phoneBook)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 form-group">
                        <div className="form-row">
                          <div className="form-group col-md-12">
                            <label htmlFor="facebook">Facebook</label>
                            <input
                              type="URL"
                              className="form-control"
                              id="facebook"
                              value={facebook}
                              onChange={(event) => onChangeHandler(event)}
                              name="facebook"
                              placeholder="Link a pagina Facebook dell'esercizio"
                            />
                            <Form.Control.Feedback type="invalid">
                              URL facebook non valida
                            </Form.Control.Feedback>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-group col-md-12">
                            <label htmlFor="instagram">Instagram</label>
                            <input
                              type="URL"
                              className="form-control"
                              id="instagram"
                              value={instagram}
                              onChange={(event) => onChangeHandler(event)}
                              name="instagram"
                              placeholder="Link a profilo Instagram dell'esercizio"
                            />
                            <Form.Control.Feedback type="invalid">
                              Url Instagram non valida
                            </Form.Control.Feedback>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-group col-md-12">
                            <label htmlFor="twitter">Twitter</label>
                            <input
                              type="URL"
                              className="form-control"
                              id="twitter"
                              value={twitter}
                              onChange={(event) => onChangeHandler(event)}
                              name="twitter"
                              placeholder="Link a profilo Twitter dell'esercizio"
                            />
                            <Form.Control.Feedback type="invalid">
                              URL Twitter non valida
                            </Form.Control.Feedback>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END Card Contatti */}

            {/* Card Orari */}
            <div className="card">
              <div className="card-header">Orari</div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label>Orari apertura</label>
                        <br />
                        <span className="small">
                          Specificare orari nei giorni di apertura e
                          deselezionare i giorni di chiusura
                        </span>
                        <WeekTable
                          // prefix = "apertura"
                          aperturaJSON={apertura}
                          aperturaTT={(apertura) => setApertura(apertura)}
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="col-md-12">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={checkCons}
                            name="checkCons"
                            onChange={(event) => handleCheckboxChange(event)}
                          />
                          <span>Effettua consegne a domicilio</span>
                        </div>
                      </div>
                    </div>
                    <div hidden={!checkCons} className="form-row">
                      <div className="col-md-12">
                        <div className="form-row">
                          <div className="form-group col-md-6">
                            <label>Orari prenotazioni</label>
                            <WeekTable
                              // prefix = "prenotazioni"
                              aperturaJSON={prenotazioni}
                              aperturaTT={(prenotazioni) =>
                                setPrenotazioni(prenotazioni)
                              }
                            />
                          </div>

                          <div className="form-group col-md-6">
                            <label>Orari consegna</label>
                            <WeekTable
                              // prefix = "consegna"
                              aperturaJSON={consegna}
                              aperturaTT={(consegna) => setConsegna(consegna)}
                            />
                          </div>
                        </div>

                        <div className="form-row">
                          {/* Modalità di pagamento */}
                          <div className="form-group col-md-6">
                            <label htmlFor="payment_method">
                              Modalità di pagamento
                            </label>
                            {checkPM.map((x, i) => {
                              return (
                                <div className="form-check" key={x.label}>
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={x.status}
                                    name={"checkPM_" + i}
                                    onChange={(event) =>
                                      mpCheckboxChange(event)
                                    }
                                  />
                                  <span>{x.label}</span>
                                </div>
                              );
                            })}
                          </div>
                          {/* END Modalità di pagamento */}

                          {/* Costo consegna */}
                          <Form.Group as={Col} md="6" controlId="description">
                            <Form.Label>Costo consegna</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={3}
                              aria-describedby="inputGroupPrepend"
                              value={costoConsegna}
                              onChange={(event) => onChangeHandler(event)}
                              name="costoConsegna"
                              placeholder="Insersci indicazioni riguardo al costo della consegna o altre informazioni utili"
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End card Orari */}

            {/* Card Scontistica */}
            <div className="card">
              <div className="card-header">
                Adesione carte sconto e scontistica
              </div>
              <div className="card-body">
                {checkCards.map((x, i) => {
                  return (
                    <div className="row" key={x.label}>
                      <div className="col-md-12">
                        <div className="form-row">
                          <div className="form-group col-md-4">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={x.status}
                                name={"checkCards_" + i}
                                onChange={(event) => cardsCheckboxChange(event)}
                              />
                              <span>{x.label}</span>
                            </div>
                          </div>
                          <div
                            hidden={!x.status}
                            className="form-group col-md-8"
                          >
                            <div className="form-row">
                              <div className="form-group col-md-6">
                                <label>Sconto applicato</label>
                                <input
                                  className="ml-1"
                                  type="number"
                                  value={x.discount}
                                  name={"discount_" + i}
                                  onChange={(event) => discountChange(event)}
                                  step="5"
                                  min="0"
                                  max="100"
                                />
                                <span className="ml-1">%</span>
                              </div>
                              <Form.Group as={Col} md="6">
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  placeholder="Specifiche sui prodotti scontati ed eventuali eccezioni"
                                  aria-describedby="inputGroupPrepend"
                                  value={x.description}
                                  onChange={(event) =>
                                    specDiscountChange(event)
                                  }
                                  name={"descr_" + i}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* END Card Scontistica */}

            {/* Card Commenti */}
            <div className="card">
              <div className="card-header">Commenti</div>
              <div className="card-body">
                {comments.map((x, i) => {
                  return (
                    <div className="row" key={x.id}>
                      <div className="col-md-12">
                        <div className="form-row">
                          <div className="form-group col-md-4">
                            <div className="form-check">
                              <input
                                id={x.id}
                                type="checkbox"
                                className="form-check-input"
                                checked={x.read}
                                name={"checkComments_" + i}
                                onChange={(event) =>
                                  commentsCheckboxChange(event)
                                }
                              />
                              <span>Visto</span>
                            </div>
                          </div>
                          <div className="form-group col-md-8">{x.text}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {/* END Card Scontistica */}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default EditTutorial;
